import React from 'react';
import block from 'bem-cn-lite';
import {compose} from 'recompose';
import {AnimateBlock} from '@yandex-data-ui/page-constructor';

import withPageContext from 'units/constructor-local/hoc/withPageContext';
import {withDesktopOnly} from 'units/constructor-local/hoc/WithDesktopOnly';
import {PageContextProps} from 'units/constructor-local/contexts/PageContext';
import {CalculatorProps} from 'units/constructor-local/models';
import {hasCalculator} from 'components/calculator/config';
import PricesCalculator from 'components/calculator/PricesCalculator/PricesCalculator';

import './Calculator.scss';

const b = block('CalculatorBlock');

type CalculatorFullProps = PageContextProps & CalculatorProps;

export const canRenderCalculator = (service?: PageContextProps['service']) => {
    return !service || hasCalculator(service.slug);
};

const CalculatorBlock: React.FC<CalculatorFullProps> = ({service, animated}) => {
    if (!canRenderCalculator(service)) {
        return null;
    }

    return (
        <AnimateBlock className={b()} animate={animated}>
            <PricesCalculator services={service && service.slug} className={b('content')} />
        </AnimateBlock>
    );
};

export default compose<CalculatorProps, PageContextProps>(
    withDesktopOnly,
    withPageContext,
)(CalculatorBlock);
